module.exports = ".file-list {\n    margin: 10px 0px;\n}\n\n.file-row {\n    margin: 6px 0px;\n}\n\n.file-name {\n    margin: 0px 4px;\n}\n\n.file-size {\n    margin: 0px 4px;\n    color: grey;\n}\n\n.file-remove {\n    cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/file-selection/file-selection.component.css
// module id = ./src/app/components/file-selection/file-selection.component.css
// module chunks = main